import React, { Component } from "react";
import { Box, Container } from "@mui/material";
import RoadMapTimeline from "../components/Timeline/RoadMapTimeline";
export default class RoadMap extends Component {
  render() {
    return (
      <section id="RoadMap" className="roadmap section-padding">
        <Container>
          <div className="heading text-center">
            <h6
              className="sub-title animated"
              data-animation="fadeInUpShorter"
              data-animation-delay="0.2s"
            >
              Roadmap
            </h6>
            <h2
              className="title animated"
              data-animation="fadeInUpShorter"
              data-animation-delay="0.3s"
            >
              <strong>Implementation </strong>Sheet
            </h2>
            <div
              className="separator animated"
              data-animation="fadeInUpShorter"
              data-animation-delay="0.3s"
            >
              <span className="large" />
              <span className="medium" />
              <span className="small" />
            </div>
            <p
              className="content-desc animated"
              data-animation="fadeInUpShorter"
              data-animation-delay="0.4s"
            >
              All aspects of our road map will be visible to our community. Any
              iterations made due to delays will be made clear to our community
              before implementation.
              <br />
              We already have a working MVP but will be making iterations to it
              in order to facilitate our new Web3 functionality.
            </p>
          </div>
          <Box>
            <RoadMapTimeline />
          </Box>
        </Container>
      </section>
    );
  }
}
